export const uiSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    label: "Edge Device Id",
                    scope: "#/properties/edge_device_id",
                    rule: {
                        effect: "DISABLE",
                        condition: {
                            scope: "#/properties/edge_device_id",
                        },
                    },
                },
                {
                    type: "Control",
                    label: "Low Power Mode",
                    scope: "#/properties/low_power_mode",
                },
                {
                    type: "Control",
                    label: "Operation Mode",
                    scope: "#/properties/operation_mode",
                },
                {
                    type: "Control",
                    label: "Server URL",
                    scope: "#/properties/server_settings/properties/server_url",
                },
            ],
        },
        // Scan Settings
        {
            type: "Group",
            label: "Scan Settings",
            elements: [
                {
                    type: "Group",
                    label: "Compressed Scan Timings",
                    elements: [
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    label: "Preheat Interval (s)",
                                    scope: "#/properties/vlp_parameters/properties/preheat_interval",
                                },
                                {
                                    type: "Control",
                                    label: "Scan Interval (s)",
                                    scope: "#/properties/scan_settings/properties/compressed_scan_interval",
                                },
                                {
                                    type: "Control",
                                    label: "Compressed Scan UDP (2500 for 15s Scan, 750 for 3s Scan)",
                                    scope: "#/properties/scan_settings/properties/numUDP",
                                },
                                {
                                    type: "Control",
                                    label: "Cube Edge (m)",
                                    scope: "#/properties/compressed_scan_settings/properties/cubeEdge_m",
                                },
                            ],
                        },
                    ],
                },
                // Lidar Parameters
                {
                    "type": "HorizontalLayout",
                    "elements": [
                        {
                            "type": "Group",
                            "label": "OS1 Specific Parameters",
                            "elements": [
                                {
                                    "type": "Group",
                                    "elements": [
                                        {
                                            "type": "HorizontalLayout",
                                            "elements": [
                                                {
                                                    "type": "Control",
                                                    "label": "Azimuth Window Start; Min: 140 Max: End Val; 180 is Straight Ahead",
                                                    "scope": "#/properties/os1_lidar/properties/azimuth_window_start"
                                                },
                                                {
                                                    "type": "Control",
                                                    "label": "Azimuth Window End; Min: Start Val; Max: 220; 180 is Straight Ahead",
                                                    "scope": "#/properties/os1_lidar/properties/azimuth_window_end"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "type": "Group",
                                    "elements": [
                                        {
                                            "type": "HorizontalLayout",
                                            "elements": [
                                                {
                                                    "type": "Control",
                                                    "label": "Number of Recording Frames, 5 is Default (30s)",
                                                    "scope": "#/properties/os1_lidar/properties/frame_count"
                                                }
                                            ]
                                        },
                                        {
                                            "type": "HorizontalLayout",
                                            "elements": [
                                                {
                                                    "type": "Control",
                                                    "label": "Scan Type, 0: Raw, 1: Compressed",
                                                    "scope": "#/properties/os1_lidar/properties/scan_type"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "type": "Group",
                            "label": "VLP Specific Parameters",
                            "elements": [
                                {
                                    "type": "Control",
                                    "label": "Azimuth Range, 0 is Straight Ahead, ex: 350-10",
                                    "scope": "#/properties/scan_settings/properties/azRange"
                                }
                            ]
                        }
                    ]
                },                         
                {
                    type: "Group",
                    label: "Post-Scan Filters",
                    elements: [
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Group",
                                    elements: [
                                        {
                                            type: "Control",
                                            scope: "#/properties/scan_settings/properties/elevRange",
                                        },
                                    ],
                                },
                                {
                                    type: "Group",
                                    elements: [
                                        {
                                            type: "Control",
                                            scope: "#/properties/scan_settings/properties/radiusRange",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "HorizontalLayout",
                                    elements: [
                                        {
                                            type: "Group",
                                            elements: [
                                                {
                                                    type: "Control",
                                                    scope: "#/properties/scan_settings/properties/x_range",
                                                },
                                            ],
                                        },
                                        {
                                            type: "Group",
                                            elements: [
                                                {
                                                    type: "Control",
                                                    scope: "#/properties/scan_settings/properties/y_range",
                                                },
                                            ],
                                        },
                                        {
                                            type: "Group",
                                            elements: [
                                                {
                                                    type: "Control",
                                                    scope: "#/properties/scan_settings/properties/z_range",
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
